// src/components/RevokeCategoryModal.jsx
// Modal dialog that collects a reason before revoking one of a handyman's
// extra categories (item B). Same pattern as RejectModal. The reason is sent
// to the handyman in a push notification, so it must be clear and specific.
// Revoking switches off their prices in that category; bookings are untouched.

import { useState } from 'react';

export default function RevokeCategoryModal({ handymanName, categoryLabel, onConfirm, onCancel, loading }) {
  const [reason, setReason] = useState('');
  const isValid = reason.trim().length >= 10;

  const handleConfirm = () => {
    if (!isValid) return;
    onConfirm(reason.trim());
  };

  return (
    // Backdrop
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onCancel}
      />

      {/* Dialog */}
      <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-md p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Revoke {categoryLabel}</h2>
        <p className="text-sm text-gray-500 mb-5">
          <span className="font-medium text-gray-700">{handymanName}</span>{' '}
          will stop offering {categoryLabel} jobs: their prices in it are switched off and
          customers no longer see them there. Existing bookings are not affected. The reason
          is sent to the handyman.
        </p>

        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          Reason (sent to the handyman, in Spanish)
        </label>
        <textarea
          rows={4}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="p. ej. Recibimos varias quejas de clientes por trabajos de esta categoría."
          autoFocus
          className="w-full px-3.5 py-2.5 border border-gray-300 rounded-lg text-sm resize-none
                     focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent
                     placeholder:text-gray-400"
        />

        <div className="flex items-center justify-between mt-1 mb-5">
          <p className={`text-xs ${reason.trim().length < 10 ? 'text-gray-400' : 'text-green-600'}`}>
            {reason.trim().length}/10 characters minimum
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onCancel}
            disabled={loading}
            className="flex-1 py-2.5 px-4 border border-gray-300 text-gray-700 text-sm font-medium
                       rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={!isValid || loading}
            className="flex-1 py-2.5 px-4 bg-red-600 hover:bg-red-700 text-white text-sm font-semibold
                       rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Revoking…' : 'Confirm revoke'}
          </button>
        </div>
      </div>
    </div>
  );
}
